import React from "react";
import styled from "styled-components";
import Modal from "../../../components/Modal";
import Button from "../../../components/Button-v2";

const ErrorModal = (props) => {
  const { open, onClose } = props;

  return (
    <Modal open={open} onClose={onClose}>
      <TextError>
        Não existe próximo status disponível para essa proposta ou seu usuário
        não tem permissão para alterar o status dessa proposta.
      </TextError>
      <ButtonWrapper>
        <Button height="34px" width="150px" onClick={onClose}>
          Ok
        </Button>
      </ButtonWrapper>
    </Modal>
  );
};

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  width: 100%;

  margin-top: 32px;
`;

const TextError = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: center;
  font-size: ${({ fontSize }) => (fontSize != undefined ? fontSize : "15px")};
  font-family: Roboto;
  width: ${({ width }) => (width != undefined ? width : "100%")};
  line-height: 14px;
  opacity: 0.9;
  color: #747576;
  height: ${({ height }) => (height != undefined ? height : "auto")};
  text-align: center;
`;

export default ErrorModal;
